<template>
  <div>
    <base-info-card
      :title="title"
      :subtitle="subtitle"
      space="4"
      color="primary"
    />
    <template v-if="!sentOk">
      <base-text-field
        v-model="msgFromName"
        label="Name"
      />

      <base-text-field
        v-model="msgFromEmail"
        label="Email"
      />

      <base-text-field
        v-model="msgSubject"
        label="Subject"
      />

      <base-textarea
        v-model="msgContent"
        class="mb-6"
        label="Your need & description"
      />
    </template>
    <vue-recaptcha
      sitekey="6LchrwEVAAAAAKHG-h4YKanOiH7eUTl5B2GvLDmK"
      :load-recaptcha-script="true"
    >
      <base-btn
        v-if="!sentOk"
        :color="!theme.isDark ? 'accent' : 'white'"
        outlined
        target="_blank"
        :disabled="sendingMsg"
        @click="sendMessage()"
      >
        Send message
      </base-btn>
    </vue-recaptcha>
    <v-alert
      v-if="sentOk"
      dense
      text
      type="success"
    >
      <strong>Message sent</strong> successfully
    </v-alert>
    <v-snackbar
      v-model="snackbar"
      bottom
      :color="snackbarColor"
    >
      {{ snackbarText }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        x
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
  import emailjs from 'emailjs-com'
  import VueRecaptcha from 'vue-recaptcha'

  export default {
    name: 'BaseContactForm',

    // Injected from the Vuetify Themeable mixin
    inject: ['theme'],
    components: { VueRecaptcha },
    props: {
      subtitle: String,
      title: {
        type: String,
        default: 'MAIL US YOUR MESSAGE',
      },
    },
    data: function () {
      return {
        msgFromName: '',
        msgFromEmail: '',
        msgSubject: '',
        msgContent: '',
        sendingMsg: false,
        sentOk: false,
        snackbar: false,
        snackbarText: '',
        snackbarColor: 'error',
        // eslint-disable-next-line no-useless-escape
        reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      }
    },
    methods: {
      sendMessage () {
        var vm = this
        if (vm.validateMessage()) {
          vm.sendingMsg = true
          var templateParams = {
            from_name: vm.msgFromName,
            from_email: vm.msgFromEmail,
            subject: vm.msgSubject,
            message_html: vm.msgContent,
          }
          emailjs.send('sendgrid_gloui_page', 'gloui_contact_form', templateParams, 'HfG0zHPc4fdM6XLFh')
            .then((result) => {
              vm.sentOk = true
              vm.sendingMsg = false
            }, (error) => {
              vm.snackbarText = 'Oops! something went wrong, try again please'
              vm.snackbar = true
              vm.sendingMsg = false
              console.log('FAILED...', error)
            })
        }
      },
      validateMessage () {
        var vm = this
        if (vm.msgFromName.trim() === '' || vm.msgFromEmail.trim() === '' || vm.msgSubject.trim() === '' || vm.msgContent.trim() === '') {
          vm.snackbarText = 'Please complete all fields to send us your message'
          vm.snackbar = true
          return false
        }
        if (!vm.isEmailValid()) {
          vm.snackbarText = 'Please enter a valid email address'
          vm.snackbar = true
          return false
        }
        return true
      },
      isEmailValid: function () {
        return (this.reg.test(this.msgFromEmail))
      },
    },
  }
</script>
<style>
  .grecaptcha-badge { visibility: hidden; }
</style>
